import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  height: 100%;
  padding: 40px 16px 10px;

  flex: 1;
  display: flex;
  flex-flow: column;
  overflow: hidden;
`

export const Title = styled.h1`
  font: normal normal 600 22px/26px Inter;
  color: ${props => props.theme.colors.color2d3139};
  margin-bottom: 32px;
`
